export default {
  storeTo: 'Magazyn do',
  weightHaveUnit: 'Waga (g)',
  productType: 'Kategoria przedmiotu',
  long: 'Długość (cm)',
  width: 'Szerokość (cm)',
  height: 'Wysokość (cm)',
  seeDetail: 'Zobacz szczegóły',
  queryTips: 'Wprowadź odpowiednie parametry, aby sprawdzić koszty wysyłki!',
  carrier: 'Przewoźnik',
  carrierCode: 'Kod przewoźnika',
  product: 'Produkt',
  productCode: 'Kod produktu',
  totalfee: 'Całkowity koszt',
  billingWeight: 'Waga płatna',
  feeEstimation: 'Szacowany koszt',
  postFeeEstimation: 'Szacunkowy koszt wysyłki',
  postFee: 'Koszt wysyłki',
  postTime: 'Szacowany czas dostawy',
  packUp: 'Zwiń',
  startWeight: 'Waga początkowa',
  endWeight: 'Waga końcowa',
  calcExpression: 'Wyrażenie obliczeniowe',
  baseFreight: 'Podstawowa opłata',
  registrationFee: 'Opłata rejestracyjna',
  noSend: 'Produkty niedostępne',
  canSend: 'Produkty dostępne',
  priceFrom: 'Szczegóły ceny',
  itemLimit: 'Limit przedmiotów',
  disReason: 'Powód niedostępności',
  BasicFreight: 'Podstawowa opłata transportowa',
  OperationFreight: 'Opłaty za zgłoszenie celne',
  RegistrationFreight: 'Opłata rejestracyjna',
  IossFee: 'Opłata IOSS',
  TariffFreight: 'Opłata celna',
  VATFregith: 'Podatek VAT',
  AserviceFee: 'Opłata za usługi dodatkowe',
  ExtraSizeFreight: 'Dopłata za ponadwymiarowość',
  AdditionalDeliveryFeeForFemoteAreas: 'Dodatkowa opłata za dostawę do obszarów odległych',
  FuelSurcharge: 'Opłata paliwowa',
  zoneCode: 'Strefa',
  amount: 'Cena',
  rate: 'Stawka',
  conditionExpression: 'Obliczenie',
  feeFactor: 'Współczynnik opłaty',
  continuedPrice: 'Cena za wagę dodatkową',
  continuedWeight: 'Waga dodatkowa (g)',
  firstPrice: 'Cena za pierwszą wagę',
  firstWeight: 'Pierwsza waga (g)',
  weightRangeStart: 'Waga początkowa (g)',
  weightRangeEnd: 'Waga końcowa (g)',
  holder: {
    toCountry: 'Wybierz miejsce docelowe',
    inputWeight: 'Wprowadź wagę',
    selectCountry: 'Wybierz kraj',
    selectCarrier: 'Wybierz przewoźnika/linię przewoźnika/kraj trasy',
    selectCategory: 'Wybierz ograniczenie przesyłki',
  },
  typeDelivery: 'Rodzaje dostawy',
  shippingTime: 'Szacowany czas dostawy',
  deliveryTips: 'Wskazówki dotyczące dostawy',
  estimatedShippingFee: 'Szacowany koszt wysyłki',
  workDay: 'dni robocze',
  lineServiceTips:
    'Uwaga: Wszystkie usługi logistyczne dla tras nieobsługiwanych bezpośrednio przez acbuy są świadczone przez zewnętrznych dostawców usług logistycznych, którzy dostosowują ceny frachtu do warunków rynkowych. W przypadku zmian cen acbuy powiadomi Cię z wyprzedzeniem. W razie problemów z usługami logistycznymi acbuy może komunikować się w Twoim imieniu z zewnętrznym dostawcą usług logistycznych.',
  logisticsStatement: '<Oświadczenie o usługach logistycznych>',
  customizedDelivery: 'Usługa dostawy indywidualnej',
  customizedDeliveryText:
    'Dostawa ładunków masowych, transport morski i kolejowy, możesz wybrać spersonalizowaną usługę dostawy',
  customizeNow: 'Dostosuj teraz',
  declareAmountRange: 'Zakres kwot deklaracji',
  viewUnavailableLines: 'Widok wyłączonych linii (wyłączony):',
  'i18n-0000001': 'Szybkość dostawy',
  'i18n-0000002':
    'Dla wszystkich paczek nadanych w okresie od {timeStart} do {timeEnd}, procent paczek, które zostały dostarczone do dnia dzisiejszego',
  'i18n-0000003': 'dni',
  couponDiscount: 'Zniżka kuponowa',
  expectedDiscount: 'Oczekiwana zniżka',
}
